// import { Calendar, ImageOff, Search } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// const OrderTable = ({
//   loading,
//   currentOrders,
//   currentPage,
//   itemsPerPage,
//   formatDate,
//   formatPrice,
//   getStatusConfig,
// }) => {

//   const navigate = useNavigate();

//   return (
//     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-6 flex-1 flex flex-col">
//       <div className="overflow-x-auto">
//         <table className="w-full border-collapse">
//           <thead>
//             <tr className="bg-blue-600 text-white text-left text-xs uppercase tracking-wider">
//               <th className="p-4 w-16 text-center">No.</th>
//               <th className="p-4">Order Id</th>
//               <th className="p-4 w-1/4">Product</th>
//               <th className="p-4">Date</th>
//               <th className="p-4">Price</th>
//               <th className="p-4">Status</th>
//               <th className="p-4">Payment</th>
//             </tr>
//           </thead>

//           <tbody className="divide-y divide-gray-100">
//             {loading ? (
//               <tr>
//                 <td colSpan="7" className="p-10 text-center text-gray-500">
//                   Loading orders...
//                 </td>
//               </tr>
//             ) : currentOrders.length === 0 ? (
//                 <tr>
//                 <td colSpan="7">
//                     <div className="flex flex-col items-center justify-center py-20 text-gray-400">
//                     <Search size={40} className="text-gray-300 mb-4" />
//                     <h3 className="text-lg font-semibold text-gray-600">
//                         No Orders Found
//                     </h3>
//                     <p className="text-sm text-gray-400 mt-1">
//                         Adjust your filters to see results.
//                     </p>
//                     </div>
//                 </td>
//                 </tr>
//             ) : (
//               currentOrders.map((order, index) => {
//                 const statusConfig = getStatusConfig(order.status);
//                 const StatusIcon = statusConfig.icon;

//                 const primaryItem = order.items?.[0];
//                 const productName =
//                   primaryItem?.productId?.productName || "Product Item";
//                 const productImage =
//                   primaryItem?.variantId?.images?.[0] || null;

//                 return (
//                   <tr
//                     key={`${order._id}-${index}-${currentPage}`}
//                     onClick={() =>
//                       navigate(`/admin-panel/all-orders/${order._id}`)
//                     }
//                     className="hover:bg-blue-50/50 cursor-pointer"
//                   >
//                     <td className="p-4 text-center text-xs font-bold text-gray-400">
//                       {(currentPage - 1) * itemsPerPage + index + 1}
//                     </td>

//                     <td className="p-4 font-mono text-sm">
//                       {order.razorpayOrderId || "N/A"}
//                       <div className="text-[10px] text-gray-400">
//                         {order.customerInfo?.name || "Guest"}
//                       </div>
//                     </td>

//                     <td className="p-4">
//                       <div className="flex items-center gap-3">
//                         <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center border">
//                           {productImage ? (
//                             <img
//                               src={productImage}
//                               alt="product"
//                               className="w-full h-full object-cover"
//                             />
//                           ) : (
//                             <ImageOff size={16} />
//                           )}
//                         </div>
//                         <div>
//                           <div className="font-semibold line-clamp-1">
//                             {productName}
//                           </div>
//                           <div className="text-xs text-gray-500">
//                             Qty: {primaryItem?.quantity || 1}
//                           </div>
//                         </div>
//                       </div>
//                     </td>

//                     <td className="p-4 flex items-center gap-2 text-gray-500 whitespace-nowrap w-full">
//                       <Calendar size={14} />
//                       {formatDate(order.createdAt)}
//                     </td>

//                     <td className="p-4 font-bold">
//                       {formatPrice(order.totalAmount)}
//                     </td>

//                     <td className="p-4">
//                       <span className="px-2 py-1 bg-gray-100 text-xs rounded">
//                         {order.orderStatus || "Processing"}
//                       </span>
//                     </td>

//                     <td className="p-4">
//                       <div
//                         className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold ${statusConfig.bg} ${statusConfig.color}`}
//                       >
//                         <StatusIcon size={14} />
//                         {statusConfig.label}
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default OrderTable;


import React from "react";
import { Calendar, ImageOff, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

const OrderTable = ({
  loading,
  currentOrders,
  currentPage,
  itemsPerPage,
  formatDate,
  formatPrice,
  getPaymentConfig,
  getFulfillmentConfig
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-6">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-blue-600 text-white text-left text-[11px] uppercase tracking-widest font-bold">
              <th className="p-4 w-16 text-center">No.</th>
              <th className="p-4">Order Details</th>
              <th className="p-4">Primary Product</th>
              <th className="p-4">Placement Date</th>
              <th className="p-4">Amount</th>
              <th className="p-4">Order Status</th>
              <th className="p-4">Payment</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100">
            {loading ? (
              <tr>
                <td colSpan="7" className="p-10 text-center text-gray-400 font-medium">
                  Fetching latest orders...
                </td>
              </tr>
            ) : currentOrders.length === 0 ? (
                <tr>
                <td colSpan="7">
                    <div className="flex flex-col items-center justify-center py-20 text-gray-400">
                      <Search size={40} className="text-gray-200 mb-4" />
                      <h3 className="text-lg font-bold text-gray-600">No Orders Found</h3>
                      <p className="text-sm text-gray-400 mt-1 uppercase tracking-tighter">Try adjusting your filters or search keywords.</p>
                    </div>
                </td>
                </tr>
            ) : (
              currentOrders.map((order, index) => {
                const payConfig = getPaymentConfig(order.paymentStatus);
                const PayIcon = payConfig.icon;

                const primaryItem = order.items?.[0];
                const productName = primaryItem?.productId?.productName || "Product Item";
                const productImage = primaryItem?.variantId?.images?.[0] || null;

                return (
                  <tr
                    key={order._id}
                    onClick={() => navigate(`/admin-panel/all-orders/${order._id}`)}
                    className="hover:bg-blue-50/40 cursor-pointer transition-colors group"
                  >
                    <td className="p-4 text-center text-xs font-bold text-gray-300 group-hover:text-blue-400">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>

                    <td className="p-4">
                      <div className="font-mono text-sm font-bold text-gray-700">
                        #{order.razorpayOrderId?.slice(6).toUpperCase()}
                      </div>
                      <div className="text-[10px] font-bold text-gray-400 uppercase tracking-tight">
                        {order.customerInfo?.name || "Guest User"}
                      </div>
                    </td>

                    <td className="p-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center border border-gray-100 shrink-0 overflow-hidden">
                          {productImage ? (
                            <img src={productImage} alt="product" className="w-full h-full object-cover" />
                          ) : (
                            <ImageOff size={16} className="text-gray-300" />
                          )}
                        </div>
                        <div className="max-w-[180px]">
                          <div className="text-sm font-bold text-gray-700 truncate">{productName}</div>
                          <div className="text-[10px] text-gray-400 font-bold uppercase">Qty: {primaryItem?.quantity || 1}</div>
                        </div>
                      </div>
                    </td>

                    <td className="p-4 whitespace-nowrap">
                      <div className="flex items-center gap-2 text-xs font-bold text-gray-500 uppercase">
                        <Calendar size={12} className="text-blue-400" />
                        {formatDate(order.createdAt)}
                      </div>
                    </td>

                    <td className="p-4 font-black text-gray-800 text-sm">
                      {formatPrice(order.totalAmount)}
                    </td>

                    <td className="p-4">
                      <span className={getFulfillmentConfig(order.status)}>
                        {order.status || "ordered"}
                      </span>
                    </td>

                    <td className="p-4">
                      <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-[10px] font-black uppercase tracking-wider ${payConfig.bg} ${payConfig.color}`}>
                        <PayIcon size={12} />
                        {payConfig.label}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderTable;